import { render, staticRenderFns } from "./RemoveCard.vue?vue&type=template&id=4e5d18ed&scoped=true&"
import script from "./RemoveCard.vue?vue&type=script&lang=js&"
export * from "./RemoveCard.vue?vue&type=script&lang=js&"
import style0 from "./RemoveCard.vue?vue&type=style&index=0&id=4e5d18ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d18ed",
  null
  
)

export default component.exports